import React from 'react';
import { Card, CardBody, CardTitle, Table } from 'reactstrap';

const dummyPricing = [
  {
    id: '1',
    pricePerUnit: 0.6,
    effectiveDate: '2025-01-01',
  },
  {
    id: '2',
    pricePerUnit: 0.65,
    effectiveDate: '2025-06-15',
  },
];

const Pricing = () => {
  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-4">Pricing</CardTitle>
        <div className="table-responsive">
          <Table className="table-nowrap mb-0">
            <thead>
              <tr>
                <th>Price per Unit</th>
                <th>Effective Date</th>
              </tr>
            </thead>
            <tbody>
              {dummyPricing.map((price) => (
                <tr key={price.id}>
                  <td>{price.pricePerUnit ? `$${price.pricePerUnit.toFixed(2)}` : 'N/A'}</td>
                  <td>{price.effectiveDate || 'N/A'}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </CardBody>
    </Card>
  );
};

export default Pricing;
